/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaVnfSecuredConfiguration } from '../shiva-vnf-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportStationTransactionsVnf } from '../fn/vnf-sites-operation/export-station-transactions-vnf';
import { ExportStationTransactionsVnf$Params } from '../fn/vnf-sites-operation/export-station-transactions-vnf';
import { exportSubscriptionTransactionsVnf } from '../fn/vnf-subscription/export-subscription-transactions-vnf';
import { ExportSubscriptionTransactionsVnf$Params } from '../fn/vnf-subscription/export-subscription-transactions-vnf';
import { exportTransactionsVnf } from '../fn/vnf-transactions/export-transactions-vnf';
import { ExportTransactionsVnf$Params } from '../fn/vnf-transactions/export-transactions-vnf';
import { getStationTransactions } from '../fn/vnf-sites-operation/get-station-transactions';
import { GetStationTransactions$Params } from '../fn/vnf-sites-operation/get-station-transactions';
import { getTransactionsOfSubscriptionVnf } from '../fn/vnf-subscription/get-transactions-of-subscription-vnf';
import { GetTransactionsOfSubscriptionVnf$Params } from '../fn/vnf-subscription/get-transactions-of-subscription-vnf';
import { TransactionPagedList } from '../models/transaction-paged-list';


/**
 * All about the VNF transaction
 */
@Injectable({ providedIn: 'root' })
export class VnfTransactionsService extends BaseService {
  constructor(config: ShivaVnfSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getStationTransactions()` */
  static readonly GetStationTransactionsPath = '/custom/stations/{uid}/transactions/search';

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationTransactions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getStationTransactions$Response(params: GetStationTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getStationTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationTransactions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getStationTransactions(params: GetStationTransactions$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getStationTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `exportStationTransactionsVnf()` */
  static readonly ExportStationTransactionsVnfPath = '/custom/stations/{uid}/transactions/export';

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStationTransactionsVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTransactionsVnf$Response(params: ExportStationTransactionsVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportStationTransactionsVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStationTransactionsVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTransactionsVnf(params: ExportStationTransactionsVnf$Params, context?: HttpContext): Observable<Blob> {
    return this.exportStationTransactionsVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportTransactionsVnf()` */
  static readonly ExportTransactionsVnfPath = '/custom/transactions/export';

  /**
   * Export transactions.
   *
   * Allows to export all the transactions as an XLSX File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportTransactionsVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTransactionsVnf$Response(params?: ExportTransactionsVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportTransactionsVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Export transactions.
   *
   * Allows to export all the transactions as an XLSX File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportTransactionsVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTransactionsVnf(params?: ExportTransactionsVnf$Params, context?: HttpContext): Observable<Blob> {
    return this.exportTransactionsVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getTransactionsOfSubscriptionVnf()` */
  static readonly GetTransactionsOfSubscriptionVnfPath = '/custom/subscriptions/{uid}/transactions';

  /**
   * Search the transactions of a subscription, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTransactionsOfSubscriptionVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfSubscriptionVnf$Response(params: GetTransactionsOfSubscriptionVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getTransactionsOfSubscriptionVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Search the transactions of a subscription, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTransactionsOfSubscriptionVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTransactionsOfSubscriptionVnf(params: GetTransactionsOfSubscriptionVnf$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getTransactionsOfSubscriptionVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `exportSubscriptionTransactionsVnf()` */
  static readonly ExportSubscriptionTransactionsVnfPath = '/custom/subscriptions/{uid}/transactions/export';

  /**
   * Export  the transactions assigned to this subscription.
   *
   * Allows to export the Subscription transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportSubscriptionTransactionsVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionTransactionsVnf$Response(params: ExportSubscriptionTransactionsVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportSubscriptionTransactionsVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Export  the transactions assigned to this subscription.
   *
   * Allows to export the Subscription transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportSubscriptionTransactionsVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportSubscriptionTransactionsVnf(params: ExportSubscriptionTransactionsVnf$Params, context?: HttpContext): Observable<Blob> {
    return this.exportSubscriptionTransactionsVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
